module.exports = __webpack_public_path__ + "static/media/github.7973a17e.svg";